import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '300px',
    overflow: 'hidden',
    display: 'inline-flex',
    flexDirection: 'column',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
  },
  contentContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `1.5rem ${theme.spacing(2)}px 2rem`,
    height: '249px',
  },
  coachImage: {
    height: '4.6875rem',
    width: '4.6875rem',
    border: `2px solid ${theme.palette.grey.warm}`,
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    justifyContent: 'center',
    objectFit: 'cover',
  },
  locationTag: {
    backgroundColor: theme.palette.blue.light100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    margin: '0.8rem auto 1.2rem',
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  iconMarker: {
    marginLeft: '-5px',
  },
  coachLocation: {
    color: theme.palette.blue.main,
    ...theme.typography.formTags,
  },
  coachName: {
    textAlign: 'center',
    color: theme.palette.blue.dark,
    marginTop: theme.spacing(2),
  },
  facilityName: {
    color: theme.palette.primary.dark,
    marginTop: theme.spacing(1),
    textAlign: 'center',
  },
  ctaContainer: {
    height: '50px',
    paddingBottom: '6px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ctaButton: {
    width: '100%',
    height: '50px',
    padding: '0',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  ctaButtonPair: {
    height: '32px',
    padding: '6px 24px',
  },
}))

export default useStyles
